import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { getMiniLocations } from "../../../store/Mini/actions";
import {
  InputChangeValue,
  SelecteChangeValue,
  PrefixCodeAdd,
  model_open,
  model_close,
} from "../../../store/Masters/PrefixCode/actions";

class AddPrefixCode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {
    this.props.getMiniLocations();
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    var data = this.props.rowdata;

    if (data.Location_id == null) {
      // var errorLoc = "Select Location";
    } else {
      if (data.name == null) {
        // var errorSubLoc = "Enter Location";
      } else {
        var prefixcodedata = {
          id: data.id,
          name: data.name,
          location_id: data.Location_id,
          screen: 1,
        };
        this.props.PrefixCodeAdd(prefixcodedata);
      }
    }
  }
  render() {
    var data = this.props.rowdata;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            Add PreFix Code
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Location_id_select"
                            className="col-form-label float-right"
                          >
                            Select Screen
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Location_id_select"
                            name="Location_id_select"
                            classNamePrefix="select2-selection"
                            isDisabled={true}
                            isClearable={
                              this.props.rowdata?.ScreenLabel ? true : false
                            }
                            // options={this.props.ScreenList.map(
                            //   (item, index) => ({
                            //     label: item.name,
                            //     value: item.id,
                            //   })
                            // )}
                            // value={{
                            //   label:
                            //     data.MenuLabel == null
                            //       ? "Select Menu"
                            //       : data.ScreenLabel,
                            //   value: data.Screen_id,
                            // }}
                            value={{ label: "PO" }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "ScreenLabel",
                                label: e?.label,
                                key2: "Screen_id",
                                value: e?.value,
                              });
                            }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Location_id_select"
                            className="col-form-label float-right"
                          >
                            Select Location
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Location_id_select"
                            name="Location_id_select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.LocationLabel ? true : false
                            }
                            options={this.props.locationslist.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              })
                            )}
                            value={{
                              label:
                                data.LocationLabel == null
                                  ? "Select Location"
                                  : data.LocationLabel,
                              value: data.Location_id,
                            }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "LocationLabel",
                                label: e?.label,
                                key2: "Location_id",
                                value: e?.value,
                              });
                            }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="MenuTitle"
                            className="col-form-label float-right"
                          >
                            PreFix Code
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="prefixcode"
                            placeholder="Enter prefix code"
                            errormessage=" Please provide a valid prefix code"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { locationslist } = state.Mini;
  const { Sublocationlist, model, rowdata } = state.PrefixCode;
  return { locationslist, Sublocationlist, model, rowdata };
};

export default connect(mapStatetoProps, {
  getMiniLocations,
  InputChangeValue,
  SelecteChangeValue,
  PrefixCodeAdd,

  model_open,
  model_close,
})(AddPrefixCode);
